<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useVuelidate } from '@vuelidate/core'
import { sameAs } from '@vuelidate/validators'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

const { t } = useI18n()
const { umsokn } = useUmsokn()

const props = defineProps<{
  disable?: boolean
}>()

// confirm must be checked
const rules = {
  umsokn: {
    confirm: { sameAs: sameAs(true) }
  }
}

const v$ = useVuelidate(rules, { umsokn })

defineExpose({
  validate() {
    v$.value.$touch()
    return !v$.value.$invalid
  }
})
</script>

<template>
  <div v-if="umsokn">
    <h2 class="form__header">{{ t('ororku_umsokn_step12_header') }}</h2>

    <v-row>
      <v-col>
        <v-checkbox
          v-model="umsokn.confirm"
          :readonly="props.disable"
          :label="t('ororku_umsokn_step12_confirm')"
          :error="v$.umsokn.confirm.$error"
          :error-messages="v$.umsokn.confirm.$error ? [t('ororku_umsokn_step12_confirmError')] : []"
        />
      </v-col>
    </v-row>

    <p>{{ t('ororku_umsokn_step12_confirmText') }}</p>
  </div>
</template>

<style scoped>
.m-t-20 {
  margin-top: 20px;
}
</style>
